export const infoProject = 'infoProject';
